import { render, staticRenderFns } from "./notification-watch.vue?vue&type=template&id=4baf588a&scoped=true"
import script from "./notification-watch.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-watch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./notification-watch.vue?vue&type=style&index=0&id=4baf588a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf588a",
  null
  
)

export default component.exports